import { useFetcherData } from "v2/hooks/useFetcherData";
import { FetcherKeys } from "routes/dataroutes/Fetchers";
import { ExtractFetcherDataType } from "routes/data-routes/types";
import { ActiveCouponsDataRoutePath, ActiveCouponsDataRouteType } from "routes/data-routes/billing-data/coupons/active-coupons/route.meta";


type HookReturnType = ReturnType<NonNullable<ActiveCouponsDataRouteType["useActiveCoupons"]>>;
type FetcherDataType = ExtractFetcherDataType<HookReturnType>;

export function useActiveCoupons(): HookReturnType {
  const { value, fetcher, reload } = useFetcherData<FetcherDataType>({
    fetcherKey: FetcherKeys.ACTIVE_COUPONS,
    fetcherHref: ActiveCouponsDataRoutePath
  });

  return {
    activeCoupons: value?.activeCoupons ?? [],
    activeCouponsError: undefined,  // TODO instead of returning CouponError as data, we should use the standard way and return proper errors here
    activeCouponsFetcher: fetcher,
    reloadActiveCoupons: reload,
  };
}
